import axiosInstance from "../lib/axios";

interface GetQuotationRequest {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
}

export interface CreateQuotationRequest {
  quotation_no: string;


  sales_id: number | null,
  delivery_time: string;
  place_of_delivery: string;

  payment: string;
  validity: string;
  quotation_date: string;

  discount: number;
  ppn: number;
  subtotal: number;
  grand_total: number;

  quotation_status_id: number,

  // Optional link to an existing customer record - lets the backend keep
  // the relation even though recipient_name/attention/email stay free text.
  customer_id?: number | null;

  items: QuotationItemRequest[];
}

export interface QuotationItemRequest {
  description: string;
  qty: number;
  unit: string;
  price: number;
  total: number;
  // Optional link to the product catalog for this line item.
  product_id?: number | null;
}

export const getQuotation = async ({
  page = 1,
  limit = 10,
  search,
  status
}: GetQuotationRequest) => {
  const body = {
    page,
    limit,
    search,
    status
  };

  const { data } = await axiosInstance.post("/Quotation/List", body);

  return data;
};



export const createQuotation = (
  data: CreateQuotationRequest
) => {
  return axiosInstance.post("/Quotation/Create", data);
};

export const getQuotationById = (id: number) => {
  return axiosInstance.get(`/Quotation/${id}`);
};

export const editQuotation = (id: number, data: any) => {
  return axiosInstance.put(`/Quotation/${id}`, data);
};

export const editStatusQuotation = (id: number, data: any) => {
  return axiosInstance.put(`/Quotation/updateStatus/${id}`, data);
};



export const deleteQuotationById = (id: number) => {
  return axiosInstance.delete(`/Quotation/${id}`);
};


export const quotationPdf = (id: number) => {
  return axiosInstance.post(`/Quotation/${id}/pdf`, null, {
    responseType: "blob", // WAJIB, kalau tidak PDF-nya bakal corrupt
  });
};


export const getQuotationStatus = async () => {
  const { data } = await axiosInstance.get("/Quotation/quotation-status");
  return data;
};